import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CanActivateViaAuthGuard } from '../../shared/services/auth.service'
import { BulkUploadOnboardingMemberComponent } from './component/bulk-upload-onboarding-member.component';
import { BulkUploadOnboardingMemberRoutingModule } from './bulk-upload.routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { BulkUploadService } from './services/bulk-upload.service';
import { HttpService } from 'app/ppm-app/shared/services/http.service';

@NgModule({
  imports: [
    CommonModule,
    BulkUploadOnboardingMemberRoutingModule,
    TranslateModule.forChild(),
    ReactiveFormsModule
  ],
  declarations: [BulkUploadOnboardingMemberComponent],
  providers: [
    CanActivateViaAuthGuard,
    BulkUploadService,
    HttpService
  ]
})
export class BulkUploadModule { }